export const TYPESCRIPT = 'TYPESCRIPT'
export const ES6 = 'ES6'
export const EMBER_DATA = 'EMBER_DATA'
export const BOOTSTRAP_3_FORM = 'BOOTSTRAP_3_FORM'



// WEBPACK FOOTER //
// ./src/constants/CodeTypes.js